<template>
	<StandardModal ref="modal">
		<h1 class="text-2xl font-serif">{{ t('your_reservation_has_changed') }}</h1>

		<p v-for="(reason, index) in reasons" :key="index" class="mt-4">{{ reason }}</p>

		<template #footer>
			<div class="flex flex-col lg:flex-row gap-4 justify-between items-center">
				<ActionButton variant="light" @click="restart">
					{{ t('start_a_new_reservation') }}
				</ActionButton>

				<ActionButton @click="keep">
					{{ t('continue_reservation') }}
				</ActionButton>
			</div>
		</template>
	</StandardModal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import ActionButton from '@/components/ActionButton.vue';
import StandardModal from '@/components/StandardModal.vue';
import { useI18n } from 'vue-i18n';

export interface Props {
  reasons: string[]
}

const { t } = useI18n();

defineProps<Props>();

const modal = ref<InstanceType<typeof StandardModal>>();

const emit = defineEmits<{
  (e: 'restart'): void
}>();

const openModal = () => {
  modal.value?.openModal();
};

const closeModal = () => {
  modal.value?.closeModal();
};

const keep = () => {
  closeModal();
};

const restart = () => {
  closeModal();
  emit('restart');
};

defineExpose({
  openModal,
  closeModal,
});
</script>
